import { FC } from 'react';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const PhilipCapital: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>PhilipCapital API Setup in 3 Steps</h3>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">Please login PhilipCapital</h2>
          <button className="stepper-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 3H21V9"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14L21 3"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <a href="https://phillip9.phillipcapital.in/#/entrylevel/login" target="_blank" rel="noreferrer">
              Open Dashboard
            </a>
          </button>
        </div>
      </li>
      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            After login, go to settings page or{' '}
            <span>
              <a href="https://Phillip9.phillipcapital.in/#/usercontrol/dashboard/settings" target="blank">
                click here
              </a>
            </span>{' '}
            then choose 10 years and generate API Key
          </h2>
          <img
            src="/images/broker_setup_guide/philip_capital/api_key.png"
            className="w-100"
            alt="PhilipCapital API page"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="PhilipCapital fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default PhilipCapital;
